import React, { Component, Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Modal, Button, Image } from "react-bootstrap";


const MinAountModal = (props) => {
    const [minAmount, setMinAmount] = useState(0);

    useEffect(() => {
        let subscription = props.subscription;
        let minAmount = 0;
        if (subscription.casual_dining) {
            minAmount = subscription?.casual_dining_status?.ordering?.home_delivery?.minimum_order_value || 0;
        } else if (subscription.fast_food_dining) {
            minAmount = subscription?.fast_food_dining?.ordering?.home_delivery?.minimum_order_value || 0;
        } else if (subscription.multi_service_business) {
            minAmount = subscription?.multi_service_business?.ordering?.home_delivery?.minimum_order_value || 0;
        }
        setMinAmount(minAmount);
    }, [props.subscription])

    return (
        <React.Fragment>
            <Modal show={true} centered>
                <Modal.Header className="border-0" closeButton>
                    <div className="f16-700">
                        Order Value is less than minimum value for home delivery
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="f16-400 mt-2 mb-4">
                        <p> {`Minimum value for this order is ${minAmount}, please add more items to continue with this Order`} </p>
                    </div>
                    <div className="mt-4">
                        <div className="row">
                            <div className="col-6">
                                <Button
                                    variant="outline-secondary"
                                    className="btn-md py-2 mb-2"
                                    style={{ width: "90%" }}
                                    onClick={props.handleCancel}
                                >
                                    Cancel
                                </Button>
                            </div>
                            <div className="col-6">
                                <Button
                                    variant="danger"
                                    className="btn-md py-2 mb-2 w-100"
                                    onClick={props.handleMenu}
                                >
                                    Go to Menu
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
};

export default MinAountModal;